import { isApproval, WorkflowLocation } from '../../helpers/matchers'

export const getItems = (phase) => {
  if (phase.items && phase.items.length) {
    return phase.items
  }
  if (phase.approvals && phase.approvals.length) {
    return phase.approvals
  }
  if (phase.tasks && phase.tasks.length) {
    return phase.tasks
  }
  return []
}

export function isFinalApprovalReached(phases = []) {
  const approvalPhases = phases.filter(
    (phase) => phase && phase.phase_type && isApproval(phase.phase_type)
  )

  return (
    !!approvalPhases.length &&
    approvalPhases[approvalPhases.length - 1].is_complete
  )
}

export const getLoaderTheme = ({ isTemplate, theme, workflowLocation }) => {
  if (theme) {
    return theme === 'dark' ? 'n3' : 'n9'
  }

  if (workflowLocation === WorkflowLocation.Popover) {
    return 'white'
  }
  if (isTemplate) {
    return 'n9'
  }
  return 'n3'
}
